import React, { useState, useEffect } from 'react';

function ModalRestriccion() {
  const [visible, setVisible] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [esBloqueado, setEsBloqueado] = useState(false);
  const [esRevision, setEsRevision] = useState(false);
  const [esNoValidado, setEsNoValidado] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      setMensaje(e.detail.mensaje);
      setEsBloqueado(e.detail.bloqueado);
      setEsRevision(e.detail.en_revision || false);
      setEsNoValidado(e.detail.no_validado || false);
      setVisible(true);
    };
    window.addEventListener('cuenta-restringida', handler);
    return () => window.removeEventListener('cuenta-restringida', handler);
  }, []);

  const cerrar = () => {
    setVisible(false);
    if (esBloqueado) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
  };

  // Dos numeros distintos a proposito: soporte para bloqueo/revision,
  // validacion para cuentas nuevas.
  const whatsappTexto = esNoValidado
    ? 'Hola, quiero validar mi cuenta para generar guías'
    : esRevision
      ? 'Hola, mi cuenta está en revisión'
      : 'Hola, necesito ayuda con mi cuenta';
  const whatsappNumero = esNoValidado ? '526143616838' : '526141964948';
  const whatsappUrl = `https://wa.me/${whatsappNumero}?text=${encodeURIComponent(whatsappTexto)}`;

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: '1rem'
    }}>
      <div style={{
        backgroundColor: 'white', borderRadius: '0.75rem',
        padding: '2rem', width: '100%', maxWidth: '28rem',
        boxShadow: '0 25px 50px rgba(0,0,0,0.5)', textAlign: 'center'
      }}>
        <div style={{
          width: '4rem', height: '4rem', borderRadius: '50%',
          backgroundColor: esBloqueado ? '#fee2e2' : esNoValidado ? '#dcfce7' : '#fef3c7',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 1rem', fontSize: '1.5rem'
        }}>
          {esBloqueado ? '🚫' : esNoValidado ? '👋' : '⚠️'}
        </div>

        <h2 style={{
          fontSize: '1.25rem', fontWeight: '700',
          color: esBloqueado ? '#991b1b' : esNoValidado ? '#166534' : '#92400e',
          marginBottom: '0.75rem'
        }}>
          {esBloqueado ? 'Cuenta Suspendida' : esNoValidado ? '¡Ya casi!' : 'Cuenta en Revision'}
        </h2>

        <p style={{ color: '#4b5563', fontSize: '0.95rem', lineHeight: '1.6', marginBottom: '1.5rem' }}>
          {mensaje}
        </p>

        <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" style={{
          display: 'inline-block', backgroundColor: '#25D366', color: 'white',
          borderRadius: '0.5rem', padding: '0.75rem 1.5rem',
          fontWeight: '600', fontSize: '1rem', textDecoration: 'none',
          marginBottom: '0.75rem', width: '100%', boxSizing: 'border-box'
        }}>
          {esNoValidado ? 'Validar mi cuenta por WhatsApp' : 'Contactar soporte por WhatsApp'}
        </a>

        <button onClick={cerrar} style={{
          display: 'block', width: '100%', padding: '0.75rem',
          backgroundColor: '#f3f4f6', color: '#374151', border: 'none',
          borderRadius: '0.5rem', cursor: 'pointer', fontSize: '0.9rem'
        }}>
          {esBloqueado ? 'Cerrar sesion' : esNoValidado ? 'Seguir explorando' : 'Entendido'}
        </button>
      </div>
    </div>
  );
}

export default ModalRestriccion;
